import React, { Component } from 'react';
import CookiesBox from '../cookiesBox';
import CookiesControl from '../cookiesControl';
import Footer from '../footer';

class FooterComponents extends Component {

    constructor(props) {
      super(props);
      this.lang = props.lang;
      this.translations=props.translations;
      this.data = props.dataProducts;

      this.state = {
        openLayer: false,
        cookiesMessageState: false
      }

      this.onClickActiveCookiesControl = this.onClickActiveCookiesControl.bind(this)
      this.onClickCloseCookiesControl = this.onClickCloseCookiesControl.bind(this)
      this.onClickCloseCookiesControl = this.onClickCloseCookiesControl.bind(this)
		}

    onClickActiveCookiesControl () {
      this.setState({openLayer: true});
    }

    onClickCloseCookiesControl () {
      this.setState({openLayer: false});
      window.localStorage.setItem('cookiesMessageBicentury', true);
    }

    onClickCloseCookiesBox () {
        this.setState({cookiesMessageState: false});
    }



    render() {

        return (

          <div >

            <Footer 
              lang={this.lang}
              data={this.data}
              translations={this.translations}
              onClickActiveCookiesControl = {this.onClickActiveCookiesControl}
            />

            <CookiesBox 
              lang={this.lang}
              translations={this.translations}
              onClickActiveCookiesControl = {this.onClickActiveCookiesControl}
              stateComp={this.state.cookiesMessageState}
            />

            <CookiesControl 
              lang={this.lang}
              translations={this.translations}
              openLayer={this.state.openLayer}
              closeLayer={this.onClickCloseCookiesControl}
              closeCookiesBox={this.onClickCloseCookiesBox}
            />

          </div>

        )
    }
};

export default FooterComponents;


// WEBPACK FOOTER //
// ./src/components/footerComponents/index.js